const getMedia = ((url:string) => {
    let url2 =  new URL(`./assets/${url}`, import.meta.url).href;
    return url2;
});

export { getMedia };